import type { ReactElement } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import type { RootState } from "../redux/store";

const AdminProtectedRoute = ({ children }: { children: ReactElement }) => {
    const { token, role } = useSelector((state: RootState) => state.adminAuth);

    if (!token) {
        return <Navigate to="/admin/login" replace />;
    }

    if (role !== "admin") {
        // If logged in as something else, redirect to dealer dashboard
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default AdminProtectedRoute;
